module.exports = __webpack_public_path__ + "static/img/banner@2x.aa10af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/banner@2x.png
// module id = UI5d
// module chunks = 44